/**
 * Tiny PostHog wrapper — uses the window.posthog snippet already injected
 * by the Emergent platform in public/index.html. No SDK needed, no bundle cost.
 *
 * Use `track(event, props?)` anywhere. Fails silently if PostHog is blocked
 * (ad-blockers, incognito, early render) — never throws.
 */

export function track(event, props) {
  try {
    if (typeof window === "undefined") return;
    const ph = window.posthog;
    if (!ph || typeof ph.capture !== "function") return;
    ph.capture(event, props || {});
  } catch (err) {
    /* analytics must never break the UI */
    console.debug("analytics.track failed silently", err);
  }
}
